document.addEventListener('DOMContentLoaded', () => {
	const form = document.getElementById('intake-form');
	if (!form) return;

	const axios = require('axios');

	const referralChoices = [
		document.getElementById('referral-choice1'),
		document.getElementById('referral-choice2'),
		document.getElementById('referral-choice3'),
	];
	const referralOptions = [
		document.getElementById('referral-option1'),
		document.getElementById('referral-option2'),
	];

	const genderChoices = document.getElementsByName('Geslacht');
	const phoneNumberInput = document.getElementById('telefoonnummer');
	const errorMessage = document.getElementById('errormessage');
	const referralValidationError = document.getElementById('referral-validation-error');
	const genderValidationError = document.getElementById('gender-validation-error');
	const isDigitalLocation = form.dataset.digitalLocation === 'true';

	const submitButton = document.getElementById('submit-intake-form');

	const updateBoxDisplay = () => {
		if (isDigitalLocation) return;

		referralOptions.forEach((option) => (option.style.display = 'none'));
		if (referralChoices[0].checked) referralOptions[0].style.display = 'block';
		if (referralChoices[1].checked) referralOptions[1].style.display = 'none';
		if (referralChoices[2].checked) referralOptions[1].style.display = 'block';
	};

	const validatePhoneNumber = () => {
		const phoneNumberRegex = /^\d{10,15}$/;
		const isPhoneNumberValid = phoneNumberRegex.test(phoneNumberInput.value);
		phoneNumberInput.classList.toggle('is-danger', !isPhoneNumberValid);
		const messageElement = phoneNumberInput.nextElementSibling;
		messageElement.classList.toggle('hidden', isPhoneNumberValid);
		return isPhoneNumberValid;
	};

	const validateReferralSelected = () => {
		if (isDigitalLocation) return true;

		const referralSelected = referralChoices.some((choice) => choice.checked);
		referralValidationError.classList.toggle('is-invisible', referralSelected);
		return referralSelected;
	};

	const validateGenderSelected = () => {
		if (!genderChoices || genderChoices.length === 0) {
			return true;
		}

		const genderSelected = Array.from(genderChoices).some(
			(radio) => radio.checked
		);

		genderValidationError.classList.toggle('is-invisible', genderSelected);
		return genderSelected;
	};

	const handleValidationOnChange = () => {
		updateBoxDisplay();
		validateReferralSelected();
	};

	if (!isDigitalLocation) {
		referralChoices.forEach((choice) =>
			choice.addEventListener('change', handleValidationOnChange)
		);
	}

	genderChoices.forEach((radio) =>
		radio.addEventListener('change', validateGenderSelected)
	);

	phoneNumberInput.addEventListener('blur', validatePhoneNumber);

	submitButton.addEventListener('click', (event) => {
		const referralSelected = validateReferralSelected();
		const genderSelected = validateGenderSelected();

		if (!referralSelected || !genderSelected) {
			event.preventDefault();
			if (!referralSelected) referralValidationError.classList.remove('is-invisible');
			if (!genderSelected) genderValidationError.classList.remove('is-invisible');
		}
	});

	form.addEventListener('submit', async (event) => {
		event.preventDefault();
		const isPhoneNumberValid = validatePhoneNumber();
		const referralSelected = validateReferralSelected();
		const genderSelected = validateGenderSelected();

		if (isPhoneNumberValid && referralSelected && genderSelected) {
			await handleFormSubmission();
		}
	});

	const handleFormSubmission = async () => {
		submitButton.disabled = true;

		try {
			const formData = new FormData(form);
			const response = await axios.post(form.dataset.api, formData);

			if (response.status && response.status === 200) {
				window.location.href = form.dataset.returnurl;
			} else {
				console.error('API request failed:', response.statusText);
				showErrorMessage();
			}
		} catch (error) {
			console.error('An error occurred:', error);
			showErrorMessage();
		}

		submitButton.disabled = false;
	};

	const showErrorMessage = () => {
		errorMessage.classList.remove('is-hidden');
	};

	updateBoxDisplay();
});
